module.exports = __webpack_public_path__ + "static/widget-img-5-25d3eeb0fcec2b90c1fe5e533753434c.png";